import { NO_SCROLL_CLASS_NAME } from '../classnames/design-system';
import { NAVIGATION_FIXED } from '../classnames/navigation';
import { PRODUCT_SUBSCRIPTION_CONTENT } from '../classnames/product-card';
import { SIDE_MENU_CONTAINER } from '../classnames/sidebar-popup';
import ThirdPartyLinksHandler from '../shared/third-party-links-handler';
import isMobileBrowser from '../utils/isMobileBrowser';
import { ACTIVE_POPUP_Z_INDEX, DEFAULT_Z_INDEX } from './constants';

export const ACTIVE_CLASS_NAME = 'side-menu__container--active';

export default class SideMenu {
  thirdPartyLinksHandler = new ThirdPartyLinksHandler();
  // TODO - It shouldn't be here. It's navigation/side-menu.
  // Remove from here + rethink/rewrite everything PRODUCT_SUBSCRIPTION_CONTENT-related!!!
  purchaseSectionContainer = document.querySelector(PRODUCT_SUBSCRIPTION_CONTENT);
  fixedNavBars = document.querySelectorAll(`.${NAVIGATION_FIXED}`);

  show = (id) => {
    // Remove position sticky of variant selector on Purchase section when opening popup
    if (this.purchaseSectionContainer && isMobileBrowser()) {
      const isContainerSticky = getComputedStyle(this.purchaseSectionContainer).position === 'sticky';

      if (isContainerSticky) {
        this.purchaseSectionContainer.style.position = 'static';
        this.purchaseSectionContainer.style.top = 'unset';
        this.purchaseSectionContainer.style.zIndex = 'unset';
      }
    }

    this.element(id)?.classList.add(ACTIVE_CLASS_NAME);
    document.body.classList.add(NO_SCROLL_CLASS_NAME);
    this.thirdPartyLinksHandler.hideForSideBar();
    // Set scroll to 0 on initial open

    if (this.element(id)?.querySelector(SIDE_MENU_CONTAINER)) {
      this.element(id).querySelector(SIDE_MENU_CONTAINER).scrollTo(0, 0);
    }

    this.fixedNavBars.forEach((navBar) => {
      navBar.style.zIndex = ACTIVE_POPUP_Z_INDEX;
    });
  };

  hide = (id) => {
    // Add position sticky of variant selector on Purchase section when opening popup
    if (this.purchaseSectionContainer && isMobileBrowser()) {
      this.purchaseSectionContainer.style.position = 'sticky';
      this.purchaseSectionContainer.style.zIndex = '1';
    }

    this.element(id).classList.remove(ACTIVE_CLASS_NAME);
    document.body.classList.remove(NO_SCROLL_CLASS_NAME);
    this.thirdPartyLinksHandler.showForSideBar();

    // Reset scroll position value
    window.restoreScrollYTo = 0;

    this.fixedNavBars.forEach((navBar) => {
      navBar.style.zIndex = DEFAULT_Z_INDEX;
    });
  };

  hideAll = () => {
    const activeSideMenus = document.getElementsByClassName(ACTIVE_CLASS_NAME);

    [...activeSideMenus].forEach((element) => {
      element.classList.remove(ACTIVE_CLASS_NAME);
      document.body.classList.remove(NO_SCROLL_CLASS_NAME);
    });

    this.thirdPartyLinksHandler.showForSideBar();
  };

  element = (id) => document.getElementById(id);

  initializeEventListeners = () => {
    const overlayElements = document.getElementsByClassName('js-side-menu-overlay');

    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
        this.hideAll();
      }
    });

    [...overlayElements].forEach((element) => element.addEventListener('click', this.hideAll));
  };
}
